import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

export class formModel {
  companyId: number = 0;
  branchId: number = 0;
}

@Component({
  selector: 'app-reverse-inventory-balances',
  templateUrl: './reverse-inventory-balances.component.html',
  styleUrls: ['./reverse-inventory-balances.component.scss'],
  standalone: false
})
export class ReverseInventoryBalancesComponent implements OnInit {
  private readonly branchService = inject(BranchService);
  private readonly companyService = inject(CompanyService);
  public config = inject(DynamicDialogConfig, { optional: true });
  private readonly formBuilder = inject(FormBuilder);
  private readonly inventoryService = inject(InventoryService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly confirmDialogService = inject(ConfirmDialogService);

  branchId = 0;
  companyId: number | null = null;
  formReverse: FormGroup = new FormGroup({});
  listBranches: any[] = [];
  listCompanies: any[] = [];

  ngOnInit() {
    this.getAllLists();
    this.validateForm(new formModel());
  }

  async getAllLists() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),
      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number) {
    if (branchId != null) {
      this.branchId = branchId;
    } else {
      this.branchId = 0;
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
    } else {
      this.companyId = null;
      this.listBranches = [];
    }
  }

  async reverseInventoryBalance() {
    if (this.formReverse.valid) {
      const confirm = await this.confirmDialogService.confirm('¿Realmente desea revertir la importación de saldos de inventario?');
      if (confirm) {
        try {
          await firstValueFrom(this.inventoryService.reverseImportBalances(this.branchId));
          this.toastHandlerService.showToast('success', `El proceso terminó exitosamente.`);
        } catch (error) {
          console.error('Error al revertir la importación de saldos.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatoria.',
      },
      branchId: {
        required: 'La sucursal es obligatoria.',
        min: 'La sucursal es obligatoria.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formReverse.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm(form: formModel) {
    this.formReverse = this.formBuilder.group({
      companyId: [form.companyId, [Validators.required, Validators.min(1)]],
      branchId: [form.branchId, [Validators.required, Validators.min(1)]]
    });
  }
}
